<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <mat-drawer-container
    (backdropClick)="closeDrawer()"
    class="flex-auto h-full dark:bg-transparent"
  >
    <!-- Drawer -->
    <mat-drawer
      class="w-full sm:w-80 dark:bg-gray-900"
      [autoFocus]="false"
      [mode]="drawerMode"
      [opened]="drawerOpened"
      #drawer
    >
      <!-- Back to Detail -->
      <a
        *ngIf="showBackButton"
        class="m-8 mr-6 mt-4 flex flex-row items-center"
        [routerLink]="customURL ? [customURL] : ['../']"
      >
        <mat-icon [svgIcon]="'heroicons_outline:arrow-sm-left'"></mat-icon>
        Back
      </a>
      <!-- Header -->
      <div class="flex items-center justify-between m-8 mr-6 sm:mt-4 sm:mb-6">
        <!-- Title -->
        <div class="text-2xl font-extrabold tracking-tight leading-none">
          Settings
        </div>
        <!-- Close button -->
        <div [class.hidden]="drawerMode === 'side'">
          <button mat-icon-button (click)="closeDrawer()">
            <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
          </button>
        </div>
      </div>
      <ng-container *ngIf="drawerMode === 'over'">
        <div class="m-6 overflow-hidden">
          <ng-content select="[slot=settings-sidebar-header]"></ng-content>
        </div>
      </ng-container>

      <!-- Panel links -->
      <div class="flex flex-col divide-y border-t border-b">
        <ng-container *ngFor="let item of navigationMenu">
          <fleet-settings-tab-label [panel]="item"> </fleet-settings-tab-label>
        </ng-container>
      </div>
    </mat-drawer>

    <!-- Drawer content -->
    <mat-drawer-content
      class="absolute inset-0 flex flex-col gap-8"
      [ngClass]="{ 'px-6 pb-12 pt-9 md:p-8 md:pb-12 lg:p-12': withPadding }"
    >
      <ng-content select="[slot=entity-header]"></ng-content>

      <ng-content select="[slot=main]"></ng-content>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
